$ = require('jquery')

require('tipso/src/tipso')


module.exports =
	init: (payload) ->
		{$target} = payload

		$target.find('.tooltip').tipso(
			position: 'top-right'
			background: '#fff'
			color: '#444'
			useTitle: true
			tooltipHover: true
		)



/** WEBPACK FOOTER **
 ** ./src/js/components/tooltip.coffee
 **/